export default __webpack_public_path__ + "static/karinar-8668ba613840c63e3bb0088ea3a54d48.webp";